import { BehaviorSubject } from 'rxjs';
import get from "lodash.get";
import * as i0 from "@angular/core";
var PanelsService = /** @class */ (function () {
    function PanelsService() {
        this.state$ = new BehaviorSubject(null);
        this.loadedItems = [];
    }
    PanelsService.prototype.markAsLoaded = function (panel) {
        try {
            this.state$.next({
                anchor: get(panel, "data.anchor.value")
            });
            this.loadedItems.push(panel);
        }
        catch (err) { }
    };
    PanelsService.prototype.getLastLoadedAnchor = function () {
        var lastLoaded = this.loadedItems[this.loadedItems.length - 1];
        if (lastLoaded)
            return lastLoaded.data.anchor.value;
    };
    PanelsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PanelsService_Factory() { return new PanelsService(); }, token: PanelsService, providedIn: "root" });
    return PanelsService;
}());
export { PanelsService };
